import { connect } from 'react-redux';
import { actions } from '../../../redux/modules/configuration';

import Configuration from './configuration';
import {resetStore} from "../../../redux/modules/login";

const ms2p = (state) => {
    return {
        ...state.configuration,
    };
};

const md2p = { ...actions, resetStore };
export default connect(ms2p, md2p)(Configuration);
